import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from './Icons';

const PlayButtonWrapper = styled.div`
  height: 60px;
  width: 60px;

  circle {
    fill: ${props => props.theme.carvana.white.primary};
  }

  path {
    fill: ${props => props.theme.carvana.blue.primary};
  }
`;

const VideoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 0;
  height: 100%;
  width: 100%;
  background-image: url("${props => props.imageUrl}");
  background-size: cover;
  cursor: pointer;
`;

const VideoPlayer = styled.iframe`
  height: 100%;
  width: 100%;
`;

class Video extends PureComponent {
  static propTypes = {
    imageUrl: PropTypes.string.isRequired,
    youtubeId: PropTypes.string.isRequired,
  };

  constructor() {
    super();

    this.state = {
      showVideo: false,
    };

    this.playVideo = this.playVideo.bind(this);
  }

  playVideo() {
    this.setState({ showVideo: true });
  }

  render() {
    const { showVideo } = this.state;
    const { imageUrl, youtubeId } = this.props;
    if (showVideo) {
      return (
        <VideoWrapper imageUrl={imageUrl}>
          <VideoPlayer
            src={`https://www.youtube.com/embed/${youtubeId}?rel=0&modestbranding=1&autoplay=1`}
            frameBorder="0"
            allowFullScreen
            title={youtubeId}
          />
        </VideoWrapper>
      );
    }

    return (
      <VideoWrapper onClick={this.playVideo} imageUrl={imageUrl}>
        <PlayButtonWrapper>
          <Icon iconName="playButton" />
        </PlayButtonWrapper>
      </VideoWrapper>
    );
  }
}

export default Video;
